import { render } from "./QuestionFormNavigation.vue?vue&type=template&id=3b6b1a6b&scoped=true&ts=true"
import script from "./QuestionFormNavigation.vue?vue&type=script&lang=ts"
export * from "./QuestionFormNavigation.vue?vue&type=script&lang=ts"

import "./QuestionFormNavigation.vue?vue&type=style&index=0&id=3b6b1a6b&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6b1a6b"]])

export default __exports__